import { Link } from "react-router-dom";

const stats = [
  { value: "6", label: "内容频道", icon: "ri-apps-2-line" },
  { value: "24", label: "在线直播", icon: "ri-live-line" },
  { value: "6", label: "签约主播", icon: "ri-star-smile-line" },
  { value: "24h", label: "不间断更新", icon: "ri-time-line" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-information-line text-base" />
              关于直播
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              一个平台，看遍多样精彩直播
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              直播是面向网络直播内容爱好者的综合平台，聚合游戏、娱乐、教育、生活、体育与音乐六大频道。我们用清晰的分类与精选推荐，帮你快速发现真正想看的内容，并通过专题策划呈现更有温度的主题合集。
            </p>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              当前站点为演示版本，所有直播数据均为静态示例，真实直播流与接口数据将在后续版本接入。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-team-line text-lg" />
                了解更多
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 rounded-md border border-background-300/60 px-5 py-2.5 text-sm font-label text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-chat-smile-2-line text-lg" />
                联系反馈
              </Link>
            </div>
          </div>

          <div className="bg-background-100 border-t lg:border-t-0 lg:border-l border-background-200/70 grid grid-cols-2">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="p-6 md:p-8 border-b border-r border-background-200/70 flex flex-col justify-center"
              >
                <span className="w-11 h-11 rounded-md bg-primary-100 flex items-center justify-center">
                  <i className={`${stat.icon} text-xl text-primary-600`} />
                </span>
                <p className="mt-4 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
                  {stat.value}
                </p>
                <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}